

<form #form="ngForm" (ngSubmit)="onSubmit(form)">
    <div class="form-row form-required">
        <label>{{ 'shared.label.email' | translate }}</label>
        <input email required type="email" name="email" [(ngModel)]="model.email" />
        <div class="form-hint">{{ 'auth.signup.hint' | translate }}</div>
    </div>

    <div class="form-row">
        <button [disabled]="form.form.invalid" class="button button-full-width button-big">{{ 'auth.signup.button.login' | translate }}</button>
    </div>

    <div class="form-row">
        <a class="form-signin" routerLink="/login">{{ 'auth.signup.signin' | translate }}</a>
    </div>
</form>
